import { useQuery } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { cartService } from 'services';

interface UsePromotionListOptions {
  enabled?: boolean;
}

export const usePromotionList = (options?: UsePromotionListOptions) => {
  return useQuery(
    `${ServerStateKeysEnum.promotionList}`,
    () => cartService.getPromotionList(),
    {
      staleTime: Infinity,
      enabled: options?.enabled ?? true,
    }
  );
};
